import React from "react";
import {
    Box,
    Typography,
    Grid,
    Card,
    TextField,
    Button,
    styled,
    Avatar,
} from "@mui/material";

import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import SchoolIcon from "@mui/icons-material/School";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

/* Premium Background */
const bgImage =
    "https://images.unsplash.com/photo-1499951360447-b19be8fe80f5";

/* Styled Components */
const PageWrapper = styled(Box)(({ theme }) => ({
    minHeight: "100vh",
    backgroundImage: `linear-gradient(rgba(16,7,32,0.90), rgba(16,7,32,0.95)), url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    paddingTop: "120px",
    paddingBottom: "80px",
    color: "white",
}));

const GlassCard = styled(Card)(({ theme }) => ({
    backgroundColor: "rgba(255,255,255,0.85)",
    backdropFilter: "blur(10px)",
    borderRadius: "14px",
    padding: "25px",
    boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
}));

const IconWrapper = styled(Avatar)(({ theme }) => ({
    backgroundColor: "goldenrod",
    color: "#100720",
    width: 60,
    height: 60,
}));

export default function PaymentPage() {
    const plans = [
        {
            title: "Student Plan",
            price: "€9.99 / month",
            icon: <SchoolIcon />,
            features: ["Beginner Courses", "Practice Exercises", "Community Access"],
        },
        {
            title: "Developer Plan",
            price: "€19.99 / month",
            icon: <RocketLaunchIcon />,
            features: ["All Courses", "Projects", "Certificates", "Code Reviews"],
        },
        {
            title: "Premium Individual",
            price: "€39.99 / month",
            icon: <WorkspacePremiumIcon />,
            features: [
                "Everything in Developer",
                "1‑on‑1 Mentorship",
                "Career Coaching",
            ],
        },
        {
            title: "Bootcamp",
            price: "€199 one‑time",
            icon: <EmojiEventsIcon />,
            features: [
                "Full Curriculum",
                "Capstone Project",
                "Interview Prep",
                "Job Guarantee*",
            ],
        },
    ];

    return (
        <PageWrapper>
            {/* Title */}
            <Box sx={{ textAlign: "center", mb: 6 }}>
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 800,
                        backgroundColor: "goldenrod",
                        color: "#100720",
                        px: 4,
                        py: 1,
                        borderRadius: "999px",
                        display: "inline-block",
                    }}
                >
                    Choose Your Plan
                </Typography>
            </Box>

            {/* Pricing Table */}
            <Grid container spacing={4} sx={{ px: { xs: 2, md: 6 }, mb: 6 }}>
                {plans.map((p, i) => (
                    <Grid item xs={12} sm={6} md={3} key={i}>
                        <GlassCard sx={{ textAlign: "center", height: "100%" }}>
                            <IconWrapper>{p.icon}</IconWrapper>

                            <Typography
                                variant="h5"
                                sx={{ fontWeight: 700, color: "#100720", mt: 2 }}
                            >
                                {p.title}
                            </Typography>

                            <Typography
                                variant="h6"
                                sx={{ color: "goldenrod", fontWeight: "bold", mt: 1 }}
                            >
                                {p.price}
                            </Typography>

                            <Box sx={{ mt: 2 }}>
                                {p.features.map((f, idx) => (
                                    <Typography key={idx} sx={{ color: "#333" }}>
                                        • {f}
                                    </Typography>
                                ))}
                            </Box>
                        </GlassCard>
                    </Grid>
                ))}
            </Grid>

            {/* Payment Form */}
            <Box sx={{ px: { xs: 2, md: 6 } }}>
                <GlassCard>
                    <Typography
                        variant="h4"
                        sx={{ fontWeight: 700, color: "#100720", mb: 3 }}
                    >
                        Payment Details
                    </Typography>

                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <TextField fullWidth label="Full Name" />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <TextField fullWidth label="Email Address" />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <TextField fullWidth label="Card Number" />
                        </Grid>

                        <Grid item xs={6} md={3}>
                            <TextField fullWidth label="Expiry" />
                        </Grid>

                        <Grid item xs={6} md={3}>
                            <TextField fullWidth label="CVV" />
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "goldenrod",
                                    color: "#100720",
                                    fontWeight: "bold",
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: "8px",
                                    "&:hover": { backgroundColor: "#e0b200" },
                                }}
                            >
                                Complete Payment
                            </Button>
                        </Grid>
                    </Grid>
                </GlassCard>
            </Box>
        </PageWrapper>
    );
}
